/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsultaHistoricoAlteracaoCadastralAliases {
  AVATAR_BENEFICIARIO = 'avatar-beneficiario',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FIELD_0 = 'field-0',
  FIELD_BENEFICIARIO = 'field-beneficiario',
  FIELD_TITULARIDADE = 'field-titularidade',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  INPUT_0 = 'input-0',
  LOCATOR_BENEFICIARIO = 'locator-beneficiario',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_BENEFICIARIO = 'mapper-beneficiario',
  PANEL_HISTORICO_ALT_CADASTRAL = 'panel-historico-alt-cadastral',
  TEXT_TITULARIDADE = 'text-titularidade',
}
export { ConsultaHistoricoAlteracaoCadastralAliases };
